<template>
  <div>
    <model-select
      v-if="items"
      placeholder="Seleziona il tipo di contratto..."
      :defaultOptions="items"
      :id="idSelected"
      :canSearch="false"
      :value="null"
      :formClass="formClass"
      :canCreate="false"
      :showTitle="false"
      :classes="classes"
      :disabled="disabled"
      @selected="onItemSelected"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from "vue-property-decorator";
import ModelSelect from "components/ModelSelect.vue";
import { RequestData } from "store/types";
import { RegisterHttp } from "utils/Decorators";
import PlaceParametersMixin from "mixins/http/PlaceParametersMixin";
import { ContractType } from "models";
import ObjectPathMixin from "mixins/ObjectPathMixin";

@Component({ components: { ModelSelect } })
export default class ContractTypeSelect extends Mixins(
  PlaceParametersMixin,
  ObjectPathMixin,
) {
  static readonly getContractTypesTag = "get_contract_types";
  @RegisterHttp(ContractTypeSelect.getContractTypesTag) http: RequestData;

  @Prop() idSelected?: string | number;
  @Prop() params;
  @Prop() formClass?: string;
  @Prop() classes?: string;
  @Prop() dataKeys?: string;
  @Prop({ default: false }) disabled?: boolean;
  @Prop() customItems: Array<{ name: string; id: number }>;

  items: Array<{ name: string; id: number }> = null;

  get queryParams() {
    return { per: 1000, ...this.params };
  }

  mounted() {
    this.customItems ? (this.items = this.customItems) : this.loadItems();
  }

  outputParams(data) {
    return this.outputObject(data, this.dataKeys);
  }

  onItemSelected(data) {
    this.$emit("change", this.outputParams(data));
  }

  loadItems() {
    this.getPlaceParameters(
      ContractType,
      this.queryParams,
      ContractTypeSelect.getContractTypesTag,
    ).then((resp) => {
      this.items = resp.filter((element) => element.disabled === false);
    });
  }
}
</script>

<style scoped></style>
